module.exports = __webpack_public_path__ + "img/C11.aad26ebf.svg";